import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const Voip = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.3844 14.7616C9.21444 13.5916 8.33244 12.2816 7.74644 10.9526C7.62344 10.6716 7.69544 10.3426 7.91244 10.1256L8.73144 9.30658C9.40244 8.63558 9.40244 7.68658 8.81644 7.10058L7.64344 5.92758C6.86244 5.14658 5.59644 5.14658 4.81544 5.92758L4.16344 6.57858C3.42244 7.31958 3.11344 8.38858 3.31344 9.44858C3.80744 12.0616 5.32544 14.9226 7.77444 17.3716C10.2234 19.8206 13.0844 21.3386 15.6974 21.8326C16.7574 22.0326 17.8264 21.7236 18.5674 20.9826L19.2184 20.3316C19.9994 19.5506 19.9994 18.2846 19.2184 17.5036L18.0454 16.3306C17.4594 15.7446 16.5094 15.7446 15.9244 16.3306L15.0214 17.2346C14.8044 17.4516 14.4754 17.5246 14.1944 17.4006C12.8654 16.8136 11.5544 15.9306 10.3844 14.7616Z"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.9531 9.89258L16.9531 3.89258"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18.9531 9.89258L19.9531 3.89258"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M21.2538 5.41258H15.1738"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M20.7333 8.37258H14.6533"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </SVGIconRender>
  );
};

export default Voip;
